import * as React from "react"
const SvgComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={280} height={230} {...props}>
    <title>{"facial-hair/* None"}</title>
  </svg>
)
export default SvgComponent
